import React from 'react'

const DownloadIconButton = props => (
  <svg width={12} height={12} viewBox="0 0 12 12" {...props}>
    <g fill="#016CAF">
      <path d="M10.8 7.8v2.4a.6.6 0 01-.6.6H1.8a.6.6 0 01-.6-.6V7.8a.6.6 0 10-1.2 0v2.4A1.8 1.8 0 001.8 12h8.4a1.8 1.8 0 001.8-1.8V7.8a.6.6 0 00-1.2 0z" />
      <path d="M6 6.951L3.424 4.376a.6.6 0 00-.848.848l3 3a.6.6 0 00.848 0l3-3a.6.6 0 00-.848-.848L6 6.95z" />
      <path d="M6.6 7.8V.6a.6.6 0 10-1.2 0v7.2a.6.6 0 101.2 0z" />
    </g>
  </svg>
)

export default DownloadIconButton
